module.exports = __webpack_public_path__ + "img/loading.7e10fe1f.png";